"use client";

import React from "react";

import styles from "./ContractVerificationPage.module.css";

const ContractVerificationPage: React.FC = () => {
  const [contractAddress, setContractAddress] = React.useState("");
  const [verificationMethod, setVerificationMethod] =
    React.useState("flattened-code");
  const [licenseType, setLicenseType] = React.useState("none");
  const [compilerVersion, setCompilerVersion] = React.useState("");
  const [sourceCode, setSourceCode] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Verification logic will be added here
    console.log("Verifying contract:", {
      contractAddress,
      verificationMethod,
      licenseType,
      compilerVersion,
      sourceCode,
    });

    setTimeout(() => setIsSubmitting(false), 2000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Verify & publish contract</h1>
        <p className={styles.subtitle}>
          Source code verification provides transparency for users interacting
          with smart contracts
        </p>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Contract address to verify</h2>
          <input
            type="text"
            className={styles.input}
            placeholder="Smart contract / Address (0x...)"
            value={contractAddress}
            onChange={(e) => setContractAddress(e.target.value)}
            required
          />
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>License type</h2>
          <select
            className={styles.select}
            value={licenseType}
            onChange={(e) => setLicenseType(e.target.value)}
          >
            <option value="none">None</option>
            <option value="unlicense">Unlicense</option>
            <option value="mit">MIT License</option>
            <option value="gpl-2.0">GNU GPLv2</option>
            <option value="gpl-3.0">GNU GPLv3</option>
            <option value="lgpl-2.1">GNU LGPLv2.1</option>
            <option value="lgpl-3.0">GNU LGPLv3</option>
            <option value="bsd-2-clause">BSD-2-Clause</option>
            <option value="bsd-3-clause">BSD-3-Clause</option>
            <option value="mpl-2.0">MPL-2.0</option>
            <option value="osl-3.0">OSL-3.0</option>
            <option value="apache-2.0">Apache-2.0</option>
            <option value="agpl-3.0">GNU AGPLv3</option>
            <option value="busl-1.1">BUSL-1.1</option>
          </select>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Verification method</h2>
          <select
            className={styles.select}
            value={verificationMethod}
            onChange={(e) => setVerificationMethod(e.target.value)}
          >
            <option value="flattened-code">
              Solidity (Flattened source code)
            </option>
            <option value="standard-input">
              Solidity (Standard JSON input)
            </option>
            <option value="multi-part">Solidity (Multi-part files)</option>
            <option value="sourcify">Sourcify</option>
            <option value="vyper-code">Vyper (Contract)</option>
            <option value="vyper-multi-part">Vyper (Multi-part files)</option>
            <option value="vyper-standard-input">
              Vyper (Standard JSON input)
            </option>
          </select>
        </div>

        {verificationMethod === "flattened-code" && (
          <>
            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>Compiler version</h2>
              <select
                className={styles.select}
                value={compilerVersion}
                onChange={(e) => setCompilerVersion(e.target.value)}
                required
              >
                <option value="">Select compiler version</option>
                <option value="v0.8.20+commit.a1b79de6">
                  v0.8.20+commit.a1b79de6
                </option>
                <option value="v0.8.19+commit.7dd6d404">
                  v0.8.19+commit.7dd6d404
                </option>
                <option value="v0.8.18+commit.87f61d96">
                  v0.8.18+commit.87f61d96
                </option>
                <option value="v0.8.17+commit.8df45f5f">
                  v0.8.17+commit.8df45f5f
                </option>
                <option value="v0.8.16+commit.07a7930e">
                  v0.8.16+commit.07a7930e
                </option>
                <option value="v0.8.15+commit.e14f2714">
                  v0.8.15+commit.e14f2714
                </option>
                <option value="v0.8.14+commit.80d49f37">
                  v0.8.14+commit.80d49f37
                </option>
                <option value="v0.8.13+commit.abaa5c0e">
                  v0.8.13+commit.abaa5c0e
                </option>
              </select>
            </div>

            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>Contract source code</h2>
              <textarea
                className={styles.textarea}
                placeholder="Enter your contract source code here..."
                value={sourceCode}
                onChange={(e) => setSourceCode(e.target.value)}
                rows={15}
                required
              />
            </div>
          </>
        )}

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Verifying..." : "Verify & publish"}
        </button>
      </form>
    </div>
  );
};

export default ContractVerificationPage;
